// faq-collapsible.js
document.addEventListener('DOMContentLoaded', function () {
  const accordion = document.querySelector('.accordion');
  if (!accordion) return;

  const openFirst = accordion.dataset.openFirst === 'true';
  const items = accordion.querySelectorAll('.accordion-item');

  // Helper function to update adjacent classes
  function updateAdjacentClasses(activeItem) {
    // Remove all active-prev and active-next classes first
    items.forEach(item => {
      item.classList.remove('active-prev', 'active-next');
    });

    // Add active-prev to previous sibling if it exists
    const prevItem = activeItem.previousElementSibling;
    if (prevItem && prevItem.classList.contains('accordion-item')) {
      prevItem.classList.add('active-prev');
    }

    // Add active-next to next sibling if it exists
    const nextItem = activeItem.nextElementSibling;
    if (nextItem && nextItem.classList.contains('accordion-item')) {
      nextItem.classList.add('active-next');
    }
  }

  items.forEach((item, index) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.accordion-content');

    // Open the first item if setting is true
    if (openFirst && index === 0) {
      item.classList.add('active');
      content.classList.add('show');
      content.style.maxHeight = content.scrollHeight + 'px';
      updateAdjacentClasses(item);
    }

    header.addEventListener('click', () => {
      // Close all other items
      items.forEach(otherItem => {
        if (otherItem !== item) {
          const otherContent = otherItem.querySelector('.accordion-content');
          otherContent.style.maxHeight = null;
          otherContent.classList.remove('show');
          otherItem.classList.remove('active');
        }
      });

      // Toggle clicked item
      if (item.classList.contains('active')) {
        content.style.maxHeight = null;
        content.classList.remove('show');
        item.classList.remove('active');
        // Remove adjacent classes when closing
        items.forEach(i => i.classList.remove('active-prev', 'active-next'));
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('show');
        item.classList.add('active');
        // Update adjacent classes when opening
        updateAdjacentClasses(item);
      }
    });
  });

  // Recalculate height on resize
  window.addEventListener('resize', () => {
    items.forEach(item => {
      const content = item.querySelector('.accordion-content');
      if (content.classList.contains('show')) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});